<div class="
    z-40
    pointer-events-none select-none
    fixed bottom-1 right-2
    flex flex-col justify-center text-right

    overflow-hidden
    bg-green-500/0
    ">
    @if (!isProduction) {
        <span class="text-red-400 opacity-60 text-shadow">
            {{ environmentName }}
        </span>
    }

    <span class="text-white opacity-35 text-shadow"> v{{ appVersion }} </span>
</div>
